// extracted by mini-css-extract-plugin
export default {"wrapper":"jC","noPadding":"kC","flavor_wrapper":"lC","flavor_button":"mC","vert":"nC","itemContent":"oC","itemName":"pC","blue":"qC","out_of_stock":"rC","newFlavorBadge":"sC","fullWidth":"tC","flavor_button_selected":"uC","black":"vC","attribute_wrapper":"wC","toggle_wrapper":"xC"};
    if(module.hot) {
      // 1743628923633
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  